module.exports = __webpack_public_path__ + "img/9971da80bcc741a5c615f8c1837036d.d0289dc0.png";